import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend';

// Direct URLs should preserve the same language as in-app navigation.
const savedLanguage = typeof window !== 'undefined' ? localStorage.getItem('language') : null;
const initialLanguage = ['en', 'ge', 'ru'].includes(savedLanguage) ? savedLanguage : 'ge';

i18n
  .use(HttpApi)
  .use(initReactI18next)
  .init({
    lng: initialLanguage,
    supportedLngs: ['en', 'ge', 'ru'],
    fallbackLng: 'ge',
    nonExplicitSupportedLngs: true,
    backend: {
      loadPath: '/locales/{{lng}}/translation.json' // Path to translation files
    },
    react: {
      useSuspense: false
    }
  });

const syncDocumentLanguage = (language) => {
  if (typeof document !== "undefined") {
    document.documentElement.lang = language === "ge" ? "ka" : language;
  }
};

i18n.on("languageChanged", syncDocumentLanguage);
syncDocumentLanguage(i18n.resolvedLanguage || i18n.language || "ge");

export default i18n;
